var _langCodesToCanonical;
import { LangCodes } from "../types";
export var defaultLangCode = LangCodes.ru_RU;
export var langCodesToCanonicalLocale = (_langCodesToCanonical = {}, _langCodesToCanonical[LangCodes.ru_RU] = 'ru-RU', _langCodesToCanonical[LangCodes.en_GB] = 'en-GB', _langCodesToCanonical);